import React from "react";
import ChatPage from "../../components/Chat/ChatPage";
import UserSideBar from "../../common/UserSidebar/UserSideBar";

const UserMessagesPage = () => (
  <ChatPage role="user" SidebarComponent={UserSideBar} />
);

export default UserMessagesPage;
